import infrastructureApi from "./InfrastructureApi";

export async function authUser() {
    try {
        const { data } = await infrastructureApi.post("/user");
        return data;
    } catch {
        return {
            success: false,
            message: "network_error",
        };
    }
}

